import { createAction } from '@reduxjs/toolkit';
import { BroadcastWSActions, BroadcastWSMessages } from 'common/constants';
import { SendReactionParams } from 'domain/Broadcast';
import { MeetingWSParams } from 'store/features/event/types/meeting.types';
import { createMeetingWSAsyncAction, createMeetingWSMessage } from 'store/utils';

import { ReceivedReaction } from './types';

export const reactionReceived_WS = createMeetingWSMessage<ReceivedReaction>(BroadcastWSMessages.ReactionReceived);

export const sendBroadcastReaction_WS = createMeetingWSAsyncAction<MeetingWSParams<SendReactionParams>>(
  BroadcastWSActions.SendReaction
);

/**
 * Room reaction received over Ably (chat v2). Reuses the same throttle → setReactions path as the
 * meeting-WS `reactionReceived_WS`, but is a plain action so it is not swallowed by the chat-v2 gate.
 */
export const ablyReactionReceived = createAction<ReceivedReaction>('reactions/ablyReactionReceived');
